module.exports = __webpack_public_path__ + "static/media/blog1.0c0fff92.jpg";